// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--gN5az","columnDirection":"columnDirection--SsR9D"};